import React from 'react';
import { auditTime, delay, timestamp } from 'rxjs';

import {
  trackChangesWhenInactive,
  useUnderEditContext,
} from '@neptune/shared/common-business-logic';
import { getEntitiesNotificationStream } from '@neptune/shared/entity-business-logic';
import { EntityType } from '@neptune/shared/entity-domain';

type UseEntityUpdatesParams = {
  entityId?: string;
  entityType: EntityType;
  projectId?: string;
  callback: (timestamp: number) => void;
};

export function useEntityAttributeDefinitionsUpdates({
  entityId,
  entityType,
  projectId,
  callback,
}: UseEntityUpdatesParams) {
  const { underEdit$ } = useUnderEditContext();

  React.useEffect(() => {
    if (!entityId || !projectId) {
      return;
    }

    const subscription = getEntitiesNotificationStream(projectId, [entityId])
      .pipe(auditTime(1200), delay(300), trackChangesWhenInactive(underEdit$), timestamp())
      .subscribe((data) => callback(data.timestamp));

    return () => subscription.unsubscribe();
  }, [callback, entityId, entityType, projectId, underEdit$]);
}
